import React from 'react';
import PropTypes from 'prop-types';

import { Button, getTranslation } from '@resy/ui-kitchen';

import './DateSelector.scss';

const DateSelector = (props) => {
  const {
    date,
    onClick,
    expanded,
  } = props;

  return (
    <Button
      id="DateSelector__button"
      variant="no-style"
      className="DateSelector"
      onClick={onClick}
      aria-expanded={expanded}
      aria-owns="ResyNav__calendar-dialog"
      data-test-id="date_selector-button-date_selector"
      aria-label={getTranslation({
        translationKey: 'date_selector',
        translationValues: { date },
        fallback: `Date ${date}`,
      })}
    >
      {date}
    </Button>
  );
};

DateSelector.propTypes = {
  date: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
};

DateSelector.displayName = 'DateSelector';
export default DateSelector;
